import React from "react";
import { useSelector } from "react-redux";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { StoreState } from "../../store/reducers";
import { getCurrentLangKey } from "../../i18n";
import { selectHelpDocument } from "../../store/selectors";

const HelpScreen = () => {

    const currentLangKey = getCurrentLangKey();
    const helpDocument = useSelector((state: StoreState) => selectHelpDocument(state, currentLangKey));

    if (!helpDocument) {
        return null;
    }

    return (<div className="markdown-styles"><ReactMarkdown children={helpDocument} remarkPlugins={[remarkGfm]} /></div>)
}

export default HelpScreen;
